import { Route, Routes } from "react-router-dom";
import Loader from "./components/layouts/loading/loading";
import React, { Suspense, useEffect } from "react";
import "./styles/style.css";
import { useDispatch, useSelector } from "react-redux";

import { getUserProfile } from "./store/SettingsSlice";
import EmployeeStatistics from "./pages/Employees/EmployeeStatistics";
import OfficeStatistics from "./pages/Employees/OfficeStatistics";
import Users from "./pages/Users/Users";

const EconomicConsultation = React.lazy(() =>
  import("./pages/Consultation/EconomicConsultation")
);
const PrivateConsultation = React.lazy(() =>
  import("./pages/Consultation/PrivateConsultation")
);
const Profile = React.lazy(() => import("./pages/Profile"));
const Admins = React.lazy(() => import("./pages/Admins/Admins"));
const Blogs = React.lazy(() => import("./pages/Inputs/Blogs"));
const ContractsType = React.lazy(() =>
  import("./pages/Contracts/ContractsType")
);
const Contracts = React.lazy(() => import("./pages/Contracts/Contracts"));
const HireLawers = React.lazy(() => import("./pages/Contracts/HireLawers"));
const AppointmentConsultations = React.lazy(() =>
  import("./pages/Consultation/AppointmentConsultations")
);
const AddAdmin = React.lazy(() => import("./pages/Admins/AddAdmin"));
const AdminEdit = React.lazy(() => import("./pages/Admins/AdminEdit"));
const Login = React.lazy(() => import("./pages/auth/login"));
const Protected = React.lazy(() => import("./pages/auth/Protected"));
const Settings = React.lazy(() => import("./pages/Setting/Settings"));
const Slider = React.lazy(() => import("./pages/Inputs/Slider"));
const ConsultationTypes = React.lazy(() =>
  import("./pages/Consultation/ConsultationTypes")
);
const Employees = React.lazy(() => import("./pages/Employees/Employees"));
const Consultant = React.lazy(() => import("./pages/Employees/Consultant"));
const Administrator = React.lazy(() =>
  import("./pages/Employees/Administrator")
);

const SpecializationEmployees = React.lazy(() =>
  import("./pages/Inputs/SpecializationEmployees")
);
const OfficeServices = React.lazy(() =>
  import("./pages/Inputs/OfficeServices")
);
const Offices = React.lazy(() => import("./pages/Employees/Offices"));

function App() {
  const dispatch = useDispatch();
  const { isAuthLoading } = useSelector((state) => state.AuthSlice);
  const { isSettingLoading, ProfileSettingArray } = useSelector(
    (state) => state.SettingsSlice
  );
  const { isHomeLoading } = useSelector((state) => state.HomeSlice);
  const { isEmployeesLoading } = useSelector((state) => state.EmployeesSlice);
  const { isContractLoading } = useSelector((state) => state.ContractSlice);
  useEffect(() => {
    if (!ProfileSettingArray) dispatch(getUserProfile());
  }, [dispatch, ProfileSettingArray]);

  return (
    <>
      {(isAuthLoading ||
        isSettingLoading ||
        isHomeLoading ||
        isEmployeesLoading ||
        isContractLoading) && <Loader />}

      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<Protected />}>
            <Route path="/" element={<Profile />} />
            <Route path="*" element={<Profile />} />
            <Route path="/profile" element={<Profile />} />
            {ProfileSettingArray?.permissions?.read_setting && (
              <Route path="/settings" element={<Settings />} />
            )}
            {ProfileSettingArray?.permissions?.read_consultationtype && (
              <Route
                path="/consultation-types"
                element={<ConsultationTypes />}
              />
            )}
            {ProfileSettingArray?.permissions?.read_economicconsultation && (
              <Route
                path="/economic-consultations"
                element={<EconomicConsultation />}
              />
            )}
            {ProfileSettingArray?.permissions?.read_privateconsultation && (
              <Route
                path="/private-consultations"
                element={<PrivateConsultation />}
              />
            )}
            {ProfileSettingArray?.permissions?.read_appointmentconsultation && (
              <Route
                path="/appointment_consultations"
                element={<AppointmentConsultations />}
              />
            )}
            {ProfileSettingArray?.permissions?.read_admin && (
              <>
                <Route path="/admins" element={<Admins />} />
                <Route path="/admins/add" element={<AddAdmin />} />
                <Route path="/admins/:id" element={<AdminEdit />} />
              </>
            )}
            {ProfileSettingArray?.permissions?.read_employee && (
              <>
                {/* EmployeeStatistics */}
                <Route path="/employees" element={<Employees />} />
                <Route
                  path="/employees/statistics/:id"
                  element={<EmployeeStatistics />}
                />
                <Route
                  path="/office/statistics/:id"
                  element={<OfficeStatistics />}
                />
                {/* OfficeStatistics */}
                <Route path="/consultant" element={<Consultant />} />
                <Route path="/administrator" element={<Administrator />} />
              </>
            )}
            {ProfileSettingArray?.permissions?.read_office && (
              <Route path="/offices" element={<Offices />} />
            )}
            {ProfileSettingArray?.permissions?.read_blog && (
              <Route path="/blogs" element={<Blogs />} />
            )}
            {ProfileSettingArray?.permissions?.read_slider && (
              <Route path="/slider" element={<Slider />} />
            )}
            {ProfileSettingArray?.permissions?.read_specializationemployee && (
              <Route
                path="/specialization-employees"
                element={<SpecializationEmployees />}
              />
            )}
            {ProfileSettingArray?.permissions?.read_officeservice && (
              <Route path="/office_services" element={<OfficeServices />} />
            )}
            {ProfileSettingArray?.permissions?.read_contracttype && (
              <Route path="/contract-type" element={<ContractsType />} />
            )}
            {ProfileSettingArray?.permissions?.read_contract && (
              <Route path="/contracts" element={<Contracts />} />
            )}
            {ProfileSettingArray?.permissions?.read_hirelawyer && (
              <Route path="/hire_lawyers" element={<HireLawers />} />
            )}

            {/* Users */}
              <Route path="/users" element={<Users />} />

            {/* {
  ProfileSettingArray?.permissions?.read_setting && 
}
{
  ProfileSettingArray?.permissions?.read_setting && 
} */}
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
